export const AXEPTIO_ALL_VENDORS = 'axeptio_all_vendors';
export const AXEPTIO_AUTHORIZED_VENDORS = 'axeptio_authorized_vendors';
export const AXEPTIO_COOKIES = 'axeptio_cookies';

export const AXEPTIO_ALL_COOKIES = [AXEPTIO_ALL_VENDORS, AXEPTIO_AUTHORIZED_VENDORS, AXEPTIO_COOKIES];
